import React from 'react';

export interface ImgIconInfoButton {
  onClick: () => void;
  img: string;
  subtitle?: string;
  mainTitle: string;
  description?: string;
}

const ImgIconInfoButton = ({ onClick, img, subtitle, mainTitle, description }: ImgIconInfoButton) => (
  <section
    className="flex items-center gap-[20px] cursor-pointer bg-grey-1 rounded-[12px] p-[18px] w-full min-h-[106px] border border-grey-3"
    onClick={onClick}
  >
    <div className="flex-shrink-0">
      <img src={img} alt="icon" className="w-[52px] h-[52px] object-contain" />
    </div>
    <div className="flex-1 flex flex-col gap-[4px]">
      {subtitle && <div className="text-gray-8 text-[14px] leading-[20px] break-keep">{subtitle}</div>}
      <div className="text-gray-8 font-bold text-[18px] leading-[22px] break-keep">{mainTitle}</div>
      {description && <div className="text-gray-8 text-[14px] leading-[20px] break-keep">{description}</div>}
    </div>
  </section>
);

export default ImgIconInfoButton;
